import { useMemo } from "react";
import { Modal, Table } from "antd";
import { useSelector } from "react-redux";
import { getAuthToken } from "Helper/AuthTokenHelper";
import { ageCalculatorFunc, formatDateToDDMMYYYY } from "utils/CommonFunctions";

const columns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (e) => {
      return e ? formatDateToDDMMYYYY(e) : "";
    },
  },
  {
    title: "Clinic Name",
    dataIndex: "clinic_name",
    key: "Clinic_name",
  },
  {
    title: "Treatment",
    dataIndex: "treatment",
    key: "Treatment",
  },
  {
    title: "EMB Transfer",
    dataIndex: "emb_transfer",
    key: "emb_transfer",
  },
  {
    title: "PG",
    dataIndex: "pg",
    key: "pg",
  },
  {
    title: "PG-Outcome",
    dataIndex: "pg_outcome",
    key: "pg_outcome",
  },
  {
    title: "No of EMB Transfer",
    dataIndex: "no_of_emb_transfer",
    key: "no_of_emb_transfer",
  },
];

const previousPregnanciesColumns = [
  {
    title: "Sr. No.",
    dataIndex: "sr_no",
    key: "sr_no",
  },
  {
    title: "In Year",
    dataIndex: "in_year",
    key: "in_year",
  },
  {
    title: "Pregnancy Outcome",
    dataIndex: "pregnancy_outcome",
    key: "pregnancy_outcome",
  },
  {
    title: "With Partner",
    dataIndex: "with_partner",
    key: "with_partner",
  },
  {
    title: "Delivery Method",
    dataIndex: "delivery_method",
    key: "delivery_method",
  },
  {
    title: "PG Week",
    dataIndex: "pg_week",
    key: "pg_week",
  },
  {
    title: "Child Died Perinatally",
    dataIndex: "child_died_perinatally",
    key: "child_died_perinatally",
  },
  {
    title: "Type of Conception",
    dataIndex: "type_of_conception",
    key: "type_of_conception",
  },
  {
    title: "Note",
    dataIndex: "note",
    key: "note",
  },
];

const PatientExtendedHistoryModal = ({ isOpen, onClose }) => {
  const userData = getAuthToken();

  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  const treatmentDetails = useMemo(() => {
    return (
      activePatientJourneyModuleDetails?.treatmentData?.map((item) => {
        return {
          ...item,
          id: Math.random().toString().substring(2, 9),
          isDelete: userData?.other === false ? true : false,
        };
      }) || []
    );
  }, [activePatientJourneyModuleDetails?.treatmentData, userData?.other]);

  const previousPregnanciesDetails = useMemo(() => {
    return (
      activePatientJourneyModuleDetails?.previous_pregnancy?.map((item, i) => {
        return {
          ...item,
          sr_no: i + 1,
          isDelete: userData?.other === false ? true : false,
        };
      }) || []
    );
  }, [activePatientJourneyModuleDetails?.previous_pregnancy, userData?.other]);

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Patient Extended History Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID</div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Age</div>
                <div>
                  {ageCalculatorFunc(
                    activePatientJourneyModuleDetails?.patient_dob
                  )}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Patient Details</div>
              <div className="details-table">
                <div>Date of Medical History</div>
                <div>
                  {activePatientJourneyModuleDetails?.date_of_medical_history
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.date_of_medical_history
                      )
                    : ""}
                </div>
              </div>
            </div>

            <div className="details">
              <div className="table-title">Menstruation Details</div>
              <div className="details-table">
                <div>Regularity</div>
                <div>{activePatientJourneyModuleDetails?.regularity}</div>
                <div>Duration (Days)</div>
                <div>{activePatientJourneyModuleDetails?.duration}</div>
                <div>Distance (Days)</div>
                <div>{activePatientJourneyModuleDetails?.distance}</div>
                <div>Intensity</div>
                <div>{activePatientJourneyModuleDetails?.intensity}</div>
                <div>Menopause (Year)</div>
                <div>{activePatientJourneyModuleDetails?.menopause}</div>
                <div>Amenorrhea (Year)</div>
                <div>{activePatientJourneyModuleDetails?.amenorrhea}</div>
                <div>Type</div>
                <div>{activePatientJourneyModuleDetails?.type}</div>
              </div>
            </div>
            {/* <div className="details">
            <div className="table-title">Previous ART Treatment</div>
            <div className="details-table">
              <div>Date</div>
              <div>{activePatientJourneyModuleDetails?.date}</div>
              <div>Clinic Name</div>
              <div>{activePatientJourneyModuleDetails?.clinic_name}</div>
              <div>Treatment</div>
              <div>{activePatientJourneyModuleDetails?.treatment}</div>
              <div>EMB Transfer</div>
              <div>{activePatientJourneyModuleDetails?.emb_transfer}</div>
              <div>PG</div>
              <div>{activePatientJourneyModuleDetails?.pg}</div>
              <div>PG-Outcome</div>
              <div>{activePatientJourneyModuleDetails?.pg_outcome}</div>
              <div>No of EMB Transfer</div>
              <div>{activePatientJourneyModuleDetails?.no_of_emb_transfer}</div>
            </div>
            </div> */}
            {/* <div className="details">
              <div className="table-title">Previous Pregnancies</div>
              <div className="details-table">
                <div>Sr. No.</div>
                <div>{activePatientJourneyModuleDetails?.sr_no}</div>
                <div>In Year</div>
                <div>{activePatientJourneyModuleDetails?.in_year}</div>
                <div>Pregnancy Outcome</div>
                <div>
                  {activePatientJourneyModuleDetails?.pregnancy_outcome}
                </div>
                <div>With Partner</div>
                <div>{activePatientJourneyModuleDetails?.with_partner}</div>
                <div>Delivery Method</div>
                <div>{activePatientJourneyModuleDetails?.delivery_method}</div>
                <div>PG Week</div>
                <div>{activePatientJourneyModuleDetails?.pg_week}</div>
                <div>Child Died Perinatally</div>
                <div>
                  {activePatientJourneyModuleDetails?.child_died_perinatally}
                </div>
                <div>Type of Conception</div>
                <div>
                  {activePatientJourneyModuleDetails?.type_of_conception}
                </div>
                <div>Note</div>
                <div>{activePatientJourneyModuleDetails?.note}</div>
              </div>
            </div> */}

            <div className="details">
              <div className="table-title">Notes</div>
              <div className="details-table">
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
              </div>
            </div>
          </div>

          <div className="cmn_table_wrap table_wrapper mb-2">
            <div className="table-title">Previous ART Treatment</div>

            <Table
              columns={columns}
              dataSource={treatmentDetails}
              pagination={false}
            />
          </div>

          <div className="cmn_table_wrap table_wrapper mb-2">
            <div className="table-title">Previous Pregnancies</div>

            <Table
              columns={previousPregnanciesColumns}
              dataSource={previousPregnanciesDetails}
              pagination={false}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PatientExtendedHistoryModal;
